export default __webpack_public_path__ + "static/media/Group 4355.607be967.svg";